export enum DurationFormat {
    Days,
    DaysHours,
    DaysHoursMinutes,
    DaysHoursMinutesSeconds,
    Hours,
    HoursMinutes,
    HoursMinutesSeconds,
    Minutes,
    MinutesSeconds,
    Seconds
}
